import s from "./ProjectCard.module.css";
import { Button } from "antd";
import { formatDate } from "../../Common/Common";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import ImportSurveysModal from "../../ProjectsView/ImportSurveysModal/ImportSurveysModal";

const DEFAULT_PROJECT_NAME = "No name provided";

export const ProjectCard = (props) => {
    const { name, project_id, last_successful_build_time } = props;
    const [selectedProjectId, setSelectedProjectId] = useState("");
    const [isImportSurveysModalOpen, setIsImportSurveysModalOpen] =
        useState(false);

    const openImportSurveysModalHandler = () => {
        setSelectedProjectId(project_id);
        setIsImportSurveysModalOpen(true);
    };

    const closeImportSurveysModalHandler = () => {
        setIsImportSurveysModalOpen(false);
        setSelectedProjectId("");
    };

    return (
        <>
            {isImportSurveysModalOpen && (
                <ImportSurveysModal
                    isOpen={isImportSurveysModalOpen}
                    onClose={closeImportSurveysModalHandler}
                    projectId={selectedProjectId}
                />
            )}
            <div className={s.card}>
                <div className={s.cardContent}>
                    <h3 className={s.cardTitle}>
                        {name || DEFAULT_PROJECT_NAME}
                    </h3>
                    <p className={s.createdAt}>
                        {" "}
                        Last Daylight Build{" "}
                        {formatDate(last_successful_build_time)}
                    </p>
                </div>
                <div className={s.cardActions}>
                    <Button
                        className={s.button}
                        size="large"
                        onClick={openImportSurveysModalHandler}
                    >
                        {" "}
                        Manage Surveys
                    </Button>
                    <Link to={`/projects/${project_id}/dashboard`}>
                        <Button type="primary" size="large">
                            Open Project
                        </Button>
                    </Link>
                </div>
            </div>
        </>
    );
};
